'use client'

import { useBIPageView } from '@/context/BISdkContext'
import { PropsWithChildren } from 'react'

export default function NewPageWrapper({ children }: PropsWithChildren) {
  useBIPageView()

  return <main className="flex flex-1 flex-col gap-6">{children}</main>
}
